import React from 'react';

import Viewer from '../components/viewer';
import { CustomFormParts, Themes } from '../utils/types';
import GenericHotspot from '../components/hotspots/generic-hotspot';
import { HotspotTypes, posterExtraButton } from '../utils/types';
import { videoEmbedGenerator, galleryGenerator, posterGenerator, customFormGenerator } from '../utils/hotspot-data-generators';
// import { openLiveChat } from '../utils/live-chat';
// import { downloadPdf } from '../utils/download-pdf';

const feedbackForm = customFormGenerator({
  title: "Feedback Survey",
  action: 'https://submit-form.com/ymY2r2Zz',
  method: 'POST',
  partsConfig: [
    CustomFormParts.para("Strathkelvin Path Survey Funded by the Scottish Government through Sustrans’ Places for Everyone programme, Northern Corridor Community Volunteers are working with TGP to investigate creating an accessible walking and cycling route joining Moodiesburn/Chryston to Glenboig, allowing for wider active travel links within the Northern Corridor. Corridor. We are looking to gather information on current and future usage and looking for your opinions on making the route better and what would help you utilise it for everyday journeys."),
    CustomFormParts.para("i.e. walking, wheeling or cycling"),
    CustomFormParts.radioChoice('How often do you use the path?', 'How often do you use the path?', ['Daily', 'Weekly', 'Fortnightly', 'Monthly', 'Very Rarely', 'Never'], true),
    CustomFormParts.radioChoice('What village do you access the path from?', "What village do you access the path from?", ['Moodiesburn', 'Chyston/ Muirhead', 'Mollinsburn', 'Glenboig', 'Gartcosh', 'Lenzie', 'Don’t use path'], true),
    CustomFormParts.input('What village do you access the path from - Other', 'text', 'Other'),
    CustomFormParts.textarea('In its present condition, how easily and safely can you access the path from your home and and exit at your destination?', 'In its present condition, how easily and safely can you access the path from your home and and exit at your destination? Please comment about all the travel modes you use i.e. walking / cycling or wheeling', true),
    CustomFormParts.radioChoice('Can you easily walk and cycle along the path itself?', 'Can you easily walk and cycle along the path itself?', ['Yes', 'No'], true),
    CustomFormParts.radioChoice('What do you use the path for ?', 'What do you use the path for ?', ['Recreation', 'School/ Education', 'Visiting Family', 'Commuting', 'Accessing Services', 'Don’t use path']),
    CustomFormParts.input('What do you use the path for - Other', 'text', 'Other'),
    CustomFormParts.radioChoice('How likely is it that you would you use the path if it were upgraded and provided a complete link between Glenboig and Moodiesburn / Chryston?', 'How likely is it that you would you use the path if it were upgraded and provided a complete link between Glenboig and Moodiesburn / Chryston?', ['Very likely', 'Likely', 'Somewhat unlikely', 'Very unlikely', 'Neither likely or unlikely'], true),
    CustomFormParts.radioChoice('What would you use the path for in future if it was improved?', 'What would you use the path for in future if it was improved?', ['Recreation', 'School/ Education', 'Visiting Family', 'Commuting', 'Accessing Services', 'Don’t use path']),
    CustomFormParts.input('What would you use the path for in future if it was improved - Other', 'text', 'Other'),
    CustomFormParts.radioChoice('What improvements would you like to see along the path?', 'What improvements would you like to see along the path?', ['Surface Improvements', 'Vegetation Management', 'Signage', 'Lighting'], true),
    CustomFormParts.input('What improvements would you like to see along the path - Other', 'text', 'Other'),
    CustomFormParts.radioChoice('How would a safe, upgraded path between Moodiesburn/Chryston and Glenboig affect the number of car journeys you make each week?', 'How would a safe, upgraded path between Moodiesburn/Chryston and Glenboig affect the number of car journeys you make each week?', ['Less car journeys', 'More car journeys'], true),
    CustomFormParts.textarea('What are your suggestions for improvements at Drumcavel Road?', 'What are your suggestions for improvements at Drumcavel Road?', true),
    CustomFormParts.textarea('Any other Comments?', 'Any other Comments?'),
    CustomFormParts.radioChoice('Are you (gender)?', 'Are you?', ['Male', 'Female', 'Other', 'Prefer not to say'], true),
    CustomFormParts.radioChoice('Are you (age)?', 'Are you?', ['Under 15', '15 - 24', '25 - 34', '35 - 44', '45-54', '55-64', '65 -74', '75 or over '], true),
    CustomFormParts.input('Please provide your home postcode (this will enable us to anonymously map the approximate location of survey respondents and will not be used for any other purpose.', 'text', 'Please provide your home postcode (this will enable us to anonymously map the approximate location of survey respondents and will not be used for any other purpose.', true),
    CustomFormParts.para('All information provided will be treated in accordance with the General Data Protection Regulations (2018) by TGP.'),
    CustomFormParts.para('Thank you for taking the time to complete this survey'),
    CustomFormParts.para(<>Want to be kept up to date on the project and be involved in the next stages? Sign up <a href="https://mailchi.mp/4edd68b76152/srp" target="_blank" >here</a></>),
    CustomFormParts.para(<>Or send us an email - <a href="mailto:nccvols@outlook.com" >nccvols@outlook.com</a></>)
  ],
});

export default function Home(props) {
  return (
    <Viewer theme={Themes.Strathkelvin} menuDefaultOpen={window.innerWidth > 800} >

      <GenericHotspot
        yaw={-0.8060526620683533}
        pitch={0.10618127534272404}
        title="Feedback Survey"
        type={HotspotTypes.CustomForm}
        data={feedbackForm}
      />

      <GenericHotspot
        yaw={-1.1959918660347655}
        pitch={0.07580395810538668}
        title="Background & Vision"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel1.png',
          extraWide: true
        })}
      />

      <GenericHotspot
        yaw={-1.6208622177225956}
        pitch={0.08180469584124044}
        title="Local Connections"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel2.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={-2.0576783753782028}
        pitch={0.08180060934409481}
        title="Issues & Constraints"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel3.png',
          extraWide: true,
          // pdfLink: 'pdfs/panel2-detail.pdf',
          // linkText: 'View boundary map in detail (PDF)'
        })}
      />

      <GenericHotspot
        yaw={-2.3551287446997986}
        pitch={0.06180894719960448}
        title="Design Areas"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel4.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={-2.6411574466854424}
        pitch={0.05680802997085542}
        title="Drumcavel Rd"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel5.png',
          extraWide: true,
          // pdfLink: 'pdfs/panel4a-detail.pdf',
          // linkText: 'View offshore environmental designations in detail (PDF)'
        })}
      />

      <GenericHotspot
        yaw={-2.913635194234776}
        pitch={0.06551339316444201}
        title="Drumcavel Rd pt. 2"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/panel6.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={0.9095985099137378}
        pitch={0.026777147547136337}
        title="Overview"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/pop1.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={1.4095985099137378}
        pitch={0.026777147547136337}
        title="Overview pt. 2"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/pop2.png',
          extraWide: true,
        })}
      />

      <GenericHotspot
        yaw={2.3020453080627125}
        pitch={0.03354605117335244}
        title="Route by drone"
        type={HotspotTypes.VideoEmbed}
        data={videoEmbedGenerator("https://player.vimeo.com/video/573040849")}
      />

      <GenericHotspot
        yaw={2.9303626167469787}
        pitch={0.03378108465987214}
        title="Route by bike"
        type={HotspotTypes.VideoEmbed}
        data={videoEmbedGenerator("https://player.vimeo.com/video/573040762")}
      />

      <GenericHotspot
        yaw={-0.046927245950757452}
        pitch={0.28389376705612705}
        title="Feedback Survey"
        type={HotspotTypes.CustomForm}
        data={feedbackForm}
      />

      <GenericHotspot
        yaw={0.019769703281273365}
        pitch={-0.02627856372395776}
        title="Exhibition details"
        type={HotspotTypes.Poster}
        data={posterGenerator({
          image: 'images/panels/whiteboard.png',
          zoomPan: false,
        })}
      />

    </Viewer>
  );
}